<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <DxGantt v-if="!updating"
             :task-list-width="500"
             :height="700"
             @task-dbl-click="onTaskDblClick"
             @scale-cell-prepared="onCellPrepared"
             scale-type="weeks">

      <DxDependencies :data-source="dependencies"/>
      <DxResources :data-source="resources"/>
      <DxResourceAssignments :data-source="resourceAssignments"/>
      <DxTasks :data-source="tasks"/>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Criar novo"
              text="Novo chamado"
              :on-click="criarNovo"/>
        </DxItem>

<!--        <DxItem name="undo" :disabled="true"/>-->
<!--        <DxItem name="redo"/>-->
        <DxItem name="separator"/>
        <DxItem name="collapseAll"/>
        <DxItem name="expandAll"/>
<!--        <DxItem name="separator"/>-->
<!--        <DxItem name="addTask"/>-->
<!--        <DxItem name="deleteTask"/>-->
        <DxItem name="separator"/>
        <DxItem name="zoomIn"/>
        <DxItem name="zoomOut"/>

        <DxItem
            location="after"
            widget="dxItem">
          <DxSwitch
              v-model:value="exibAberto"
              switchedOnText="Exibir Em Aberto"
              switchedOffText="Exibir Todos"
              width="100px"
              @value-changed="mudouExib"
              :disabled="false"/>
        </DxItem>

      </DxToolbar>

      <DxEditing :enabled="false"/>
      <DxValidation :auto-update-parent-tasks="true"/>

      <DxColumn
          data-field="id"
          caption="ID"/>

      <DxColumn
          data-field="dbase"
          caption="Origem"/>

      <DxColumn
          data-field="status"
          caption="Status"
          alignment="left"
          data-type="text"
          :customize-text="nomeStatus"
          :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
          :allowHeaderFiltering="true">
      </DxColumn>

      <DxColumn
          data-field="title"
          caption="Título"/>

      <DxColumn
          data-field="start_fmt"
          data-type="date"
          format="dd/MM/yyyy"
          caption="Início"/>

<!--      <DxColumn-->
<!--          data-field="end_fmt"-->
<!--          data-type="date"-->
<!--          format="dd/MM/yyyy"-->
<!--          caption="Fechamento"/>-->

    </DxGantt>



    <b-modal v-if="chamadoData"
             size="lg"
             :title="`${chamadoData.id ? 'Detalhes Chamado ' + chamadoData.id + ' (' + chamadoData.status + ')': 'Criando Novo Chamado'}`"
             v-model="showModalChamado"
             centered hide-footer>

      <div class="row">

        <div class="col-lg-6">
          <div class="mb-3">
            <label for="titulo">Título</label>
            <div class="position-relative">
              <input
                  id="titulo"
                  v-model="chamadoData.titulo"
                  type="text"
                  class="form-control"
                  placeholder="Breve descrição"
                  :disabled="true"
                  :class="{'is-invalid': submmitedChamado && !chamadoData.titulo }"/>
              <div v-if="submmitedChamado && !chamadoData.titulo" class="invalid-feedback">
                <span>Campo título obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="mb-3">
            <label for="setor">Setor</label>
            <select
                id="setor"
                v-model="chamadoData.setor"
                :disabled="true"
                class="form-control"
                :class="{'is-invalid': submmitedChamado && !chamadoData.setor}">
              <option value="ST">Suporte Técnico</option>
              <option value="DZ">Desenvolvimento</option>
            </select>
            <div v-if="submmitedChamado && !chamadoData.setor" class="invalid-feedback">
              <span>Campo setor obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>


        <div class="col-lg-6">
          <div class="mb-3">
            <label for="inicio">Início</label>
            <input
                id="inicio"
                v-model="chamadoData.inicio_fmt"
                :disabled="true"
                type="date"
                class="form-control"
                placeholder="Data de Início"/>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="mb-3">
            <label for="fechamento">Fechamento</label>
            <input
                id="fechamento"
                v-model="chamadoData.fechamento_fmt"
                :disabled="true"
                type="date"
                class="form-control"
                placeholder="Data de fechamento"/>
          </div>
        </div>


        <div class="col-lg-12">
          <div class="mb-3">
            <label for="descricao">Descrição</label>
            <div class="position-relative">
                  <textarea
                      id="descricao"
                      v-model="chamadoData.descricao"
                      :disabled="true"
                      type="text"
                      rows="10"
                      class="form-control"
                      placeholder="Descrição completa do ocorrido, URL (endereço de página) nos ajudaria muito... "
                      :class="{'is-invalid': submmitedChamado && !chamadoData.descricao }"/>
              <div v-if="submmitedChamado && !chamadoData.descricao" class="invalid-feedback">
                <span>Campo descrição obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>
        </div>

      </div>


      <div class="row">

        <h4 class="card-title">Evolução</h4>
        <b-progress :value="chamadoData.progresso"
                    :min="0"
                    :max="100"
                    class="mb-4"
                    variant="info"
                    animated>

        </b-progress>

      </div>

      <div class="row">

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalChamado = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <b-button type="submit" variant="outline-warning" class="ms-1"
                    v-if="chamadoData.id > 0"
                    @click="editarChamado">
            <i class="bx bxs-pencil font-size-16 align-middle me-2"></i>
            Editar Chamado
          </b-button>




        </div>

      </div>




    </b-modal>


  </Layout>
</template>

<script>
import 'devextreme/dist/css/dx.light.css';
import 'devexpress-gantt/dist/dx-gantt.css';
import {
  DxGantt, DxTasks, DxDependencies, DxResources, DxResourceAssignments,
  DxToolbar, DxItem, DxEditing, DxValidation, DxColumn
} from 'devextreme-vue/gantt';
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import DxButton from "devextreme-vue/button";
import moment from "moment";
import api from "@/axios";
import Swal from "sweetalert2";
import Loader from "@/router/views_mobagile/components/loader.vue";
import {DxSwitch} from "devextreme-vue/switch";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: {
    DxSwitch,
    Loader,
    DxButton,
    Layout, PageHeader,
    DxGantt, DxTasks, DxDependencies, DxResources, DxResourceAssignments,
    DxToolbar, DxItem, DxEditing, DxValidation, DxColumn,
  },
  data() {
    return {
      title: "Chamados",
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Chamados",
          active: true
        }
      ],

      dtlistPesqChamado: null,

      showModalChamado: false,
      chamadosData: null,
      chamadoData: {},
      submmitedChamado: false,
      errosValid: null,
      updating: false,

      tasks: [],

      dependencies: [{
        id: 1,
        predecessorId: 3,
        successorId: 4,
        type: 0,
      }, {
        id: 2,
        predecessorId: 4,
        successorId: 5,
        type: 0,
      }, {
        id: 3,
        predecessorId: 5,
        successorId: 6,
        type: 0,
      }, {
        id: 4,
        predecessorId: 6,
        successorId: 7,
        type: 0,
      }, {
        id: 5,
        predecessorId: 7,
        successorId: 9,
        type: 0,
      }, {
        id: 6,
        predecessorId: 9,
        successorId: 10,
        type: 0,
      }, ],
      resources: [],
      resourceAssignments: [],
      exibAberto: true
    }
  },
  computed: {

  },

  mounted() {
    this.carregarDados()
  },

  methods: {

    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.carregarDados()
    },


    nomeStatus(e) {

      switch (e.value) {
        case 'AB':
          return 'Aberto (AB)'
        case 'FE':
          return 'Fechado (FE)'
      }
      return e.value
    },





    editarChamado(){
      console.log('editarChamado')


      const routeData = this.$router.resolve(`/chamado/editar/${this.chamadoData.id}`)
      window.open(routeData.href, '_blank')


    },





    pesqChamado(evt){
      console.log('pesqChamado')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqChamado = null
        api.get(`${getBaseUrl()}api/chamapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqChamado = res.data
        })
      }
    },


    onTaskDblClick(evt) {
      console.log('onTaskDblClick')
      console.log(evt.data.id)
      this.chamadoData = this.chamadosData.find((reg) => reg.id === evt.data.id)

      this.chamadoData.inicio_fmt = moment(this.chamadoData.inicio).format('YYYY-MM-DD')
      this.chamadoData.fechamento_fmt = moment(this.chamadoData.fechamento).format('YYYY-MM-DD')

      console.log(this.chamadoData)

      evt.cancel = true
      this.showModalChamado = true
    },

    carregarDados(){
      this.updating = true
      api.get(`${getBaseUrl()}api/chamados`,{
        params: {
          'ea': this.exibAberto,
        }
      }).then((res) => {
        console.log('then axios chamadosList')
        console.log(res.data)
        // console.log('this.tasks_01')
        // console.log(this.tasks)
        this.chamadosData = res.data[0]
        this.tasks = []
        this.resources = []
        this.resourceAssignments = []
        let idResource = 1
        let idResourceAssign = 1
        this.chamadosData.forEach((chamado) => {
          // console.log('chamado')

          this.chamadosData.progresso = 0
          this.tasks.push({
            'id': chamado.id,
            'parentId': chamado.chamado_id,
            'title': chamado.titulo,
            'start': new Date(chamado.inicio),
            'end': new Date(chamado.fechamento),
            'start_fmt': moment(chamado.inicio),
            'end_fmt': moment(chamado.fechamento),
            'progress': chamado.progresso,
            'color': chamado.cor,
            'status': chamado.status,
            'dbase': chamado.dbase,
          })

          this.resources.push({
            id: idResource,
            text: chamado.updated_by
          })

          this.resourceAssignments.push({
            id: idResourceAssign,
            taskId: chamado.id,
            resourceId: idResource
          })

          idResource += 1
          idResourceAssign++

        })
        this.updating = false
        console.log('this.tasks_2')
        console.log(this.tasks)
      })
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'AB':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'FE':
              corStatus = 'rgba(33,78,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = 'rgba(0,0,0,0.38)'
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }
      }
    },

    confChamado() {
      console.log('confChamado')
      console.log(this.chamadoData)
      if (this.chamadoData.id > 0 && this.chamadoData.id === this.chamadoData.chamado_id) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Chamado pai deve ser diferente do chamado em edição",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.submmitedChamado = true
        this.chamadoData.inicio = this.chamadoData.inicio_fmt
        this.chamadoData.fechamento = this.chamadoData.fechamento_fmt
        if (this.chamadoData.titulo && this.chamadoData.setor && this.chamadoData.descricao && this.chamadoData.progresso <= 100) {
          this.showModalChamado = false
          this.updating = true
          api.post(`${getBaseUrl()}api/chamado`, {
            chamadoData: this.chamadoData
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            this.updating = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false
          })
        }
      }
    },

    criarNovo() {

      const routeData = this.$router.resolve(`/chamado/editar/0`)
      window.open(routeData.href, '_blank')
    },


  }
}
</script>
